import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';

@Component({
  selector: 'app-duna-add-event-users',
  standalone: true,
  imports: [DynamicFormComponent],
  templateUrl: './duna-add-event-users.component.html',
  styleUrl: './duna-add-event-users.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DunaAddEventUsersComponent {
  readonly dynamicInput = {
    bundledSurveyForm: { type: 'text', value: 'add-event-users' },
    formReceiveFunction: { type: 'text', value: 'update_event_users' },
    surveyJSON: { type: 'surveyJSON', value: '{}' },
  };
}
